export function formatMemberCSV(memberStr, dataStr) {
    const lines = memberStr.split(/\n|\r/gm);
    const memberName = lines[0].replace(/Attendance Chart for |"|,/gm, "");
    const memberElem = document.querySelector(`#members option[data-name="${memberName}"]`);
    const columns = `"member","id",${lines.splice(3, 1)}"groups"`; // add members to columns and remove
    lines.splice(0, 3); // remove the first 3 lines
    dataStr !== null && dataStr !== void 0 ? dataStr : (dataStr = columns); // set columns on first pass
    lines.forEach((line) => {
        if (line.length) {
            dataStr += `\n"${memberName}","${(memberElem === null || memberElem === void 0 ? void 0 : memberElem.dataset.id) || ""}",${line}"${(memberElem === null || memberElem === void 0 ? void 0 : memberElem.dataset.groups) || ""}"`;
        }
    });
    return dataStr;
}
